import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { articleAPI } from '../services/api';

const UZ_MONTHS = [
  'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
  'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь',
];

const formatPublishedDate = (dateStr) => {
  const d = new Date(dateStr);
  return `${d.getDate()} ${UZ_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

const ARTICLES = [
  {
    slug: 'kak-oformit-razvod',
    categoryUz: 'Оила ҳуқуқи',
    categoryRu: 'Семейное право',
    readTimeUz: '5 дақ',
    readTimeRu: '5 мин',
    titleUz: 'Ўзбекистонда ажрашиш тартиби',
    titleRu: 'Как оформить развод в Узбекистане',
    excerptUz: 'Ажрашиш — никоҳни бекор қилишнинг ҳуқуқий жараёни. Ўзбекистонда у Оила кодекси билан тартибга солинади. Қандай ҳужжатлар керак ва қаёққа мурожаат қилиш кераклигини биліп олинг.',
    excerptRu: 'Развод — это юридический процесс расторжения брака. В Узбекистане он регулируется Семейным кодексом. Узнайте, какие документы нужны и куда обращаться.',
    contentUz: `
## Ўзбекистонда ажрашиш тартиби

Ўзбекистон Республикасида никоҳни бекор қилиш Оила кодекси билан тартибга солинади. Ажрашишнинг икки йўли мавжуд: ФҲДЁ органи (фуқаролик ҳолатлари далолатномалари ёзуви) орқали ва суд орқали.

### ФҲДЁ орқали ажрашиш

Қуйидаги шартлар бир вақтда бажарилса ФҲДЁ орқали ажрашиш мумкин:
- Ҳар иккала эр-хотин ажрашишга розилар
- Оилада вояга етмаган болалар йўқ
- Мол-мулк бўйича низолар йўқ

**Зарур ҳужжатлар:**
1. Ҳар иккала эр-хотиннинг биргаликдаги аризаси
2. Иккала томоннинг паспорти
3. Никоҳ гувоҳномаси
4. Давлат божи тўланганлиги тўғрисидаги квитанция

Кўриб чиқиш муддати — ариза берилган кундан бошлаб бир ой.

### Суд орқали ажрашиш

Агар қуйидаги ҳолатлар мавжуд бўлса суд тартибида ажрашилади:
- Эр-хотиндан бири ажрашишга рози эмас
- Вояга етмаган болалар мавжуд
- Мол-мулкни бўлиш ёки алимент бўйича низолар бор

**Ҳаракатлар тартиби:**
1. Туман (шаҳар) судига даъво аризасини тайёрланг
2. Зарур ҳужжатларни илова қилинг
3. Давлат божини тўланг
4. Суд мажлисларида иштирок этинг

Одатда суд ярашиш учун 3 ойгача муҳлат беради.

### Мол-мулкни бўлиш

Никоҳ давомида орттирилган мол-мулк умумий мулк ҳисобланади. Ажрашишда никоҳ шартномасида бошқача назарда тутилмаган бўлса, у тенг бўлинади.

*Ўз вазиятингиз бўйича якка тартибда маслаҳат олиш учун адвокатга мурожаат қилинг.*
    `,
    contentRu: `
## Как оформить развод в Узбекистане

Расторжение брака в Узбекистане регулируется Семейным кодексом Республики Узбекистан. Существует два способа оформить развод: через ЗАГС и через суд.

### Развод через ЗАГС

Расторжение брака через ЗАГС возможно при одновременном соблюдении следующих условий:
- Оба супруга согласны на развод
- В семье нет несовершеннолетних детей
- Нет споров об имуществе

**Необходимые документы:**
1. Совместное заявление обоих супругов
2. Паспорта обоих супругов
3. Свидетельство о браке
4. Квитанция об уплате государственной пошлины

Срок рассмотрения — один месяц с момента подачи заявления.

### Развод через суд

Судебный порядок расторжения брака применяется, если:
- Один из супругов не согласен на развод
- Есть несовершеннолетние дети
- Есть споры о разделе имущества или алиментах

**Порядок действий:**
1. Подготовить исковое заявление в районный суд
2. Приложить необходимые документы
3. Уплатить государственную пошлину
4. Участвовать в судебных заседаниях

Суд, как правило, даёт срок для примирения — до 3 месяцев.

### Раздел имущества

Имущество, нажитое в браке, считается совместной собственностью. При разводе оно делится поровну, если иное не предусмотрено брачным договором.

*Обратитесь к адвокату для получения индивидуальной консультации по вашей ситуации.*
    `,
  },
  {
    slug: 'prava-arendatora',
    categoryUz: 'Уй-жой ҳуқуқи',
    categoryRu: 'Жилищное право',
    readTimeUz: '4 дақ',
    readTimeRu: '4 мин',
    titleUz: 'Ижарачи ҳуқуқлари: нимани билиш керак',
    titleRu: 'Права арендатора в Узбекистане: что нужно знать',
    excerptUz: 'Уй ижарага олдингизми? Ҳуқуқ ва мажбуриятларингиз, иjaradорчи шартномани бузса нима қилиш ва гаровни қандай қайтариш ҳақида билинг.',
    excerptRu: 'Снимаете жильё? Узнайте о своих правах и обязанностях, что делать если арендодатель нарушает договор, и как вернуть залог.',
    contentUz: `
## Ўзбекистонда ижарачи ҳуқуқлари

Ўзбекистонда уй-жой ижараси ЎзР Фуқаролик кодекси билан тартибга солинади. Ижарачи шартнома имзолашдан олдин билиши шарт бўлган муҳим ҳуқуқларга эга.

### Ижарачининг асосий ҳуқуқлари

**1. Тегишли ҳолатдаги уй-жойга ҳуқуқ**
Иjaradор яшашга яроқли ҳолатда уй-жой топшириши шарт.

**2. Уй-жой дахлсизлигига ҳуқуқ**
Иjaradор олдиндан хабар бермасдан (одатда 24 соат олдин) ижарага олинган жойга кира олмайди.

**3. Ўз вақтида таъмирлаш ҳуқуқи**
Капитал таъмирот — иjaradорнинг мажбурияти, жорий (майда) таъмирот — одатда ижарачининг мажбурияти.

**4. Гаровни қайтариш**
Гаров (депозит) ижара тугагандан кейин оқилона муддат ичида қайтарилиши шарт, агар ижарачи мол-мулкка зиён етказмаган бўлса.

### Иjaradор ҳуқуқларингизни бузса нима қилиш керак?

1. Бузилишларни ёзма равишда қайд этинг (фото, ёзишмалар)
2. Иjaradорга ёзма даъво юборинг
3. Ҳуқуқларни ҳимоя қилиш тўғрисидаги даъво билан судга мурожаат қилинг

### Ижара шартномасини тузишдаги маслаҳатлар

- Ҳар доим ёзма шартнома тузинг
- Мол-мулкнинг рўйхати билан қабул-топшириш далолатномасини тузинг
- Иjaradорнинг мулкка эгалик ҳужжатларини текширинг
- Счётчик кўрсаткичларини қайд этинг

*Узоқ муддатли ижара шартномасини имзолашдан олдин адвокат билан маслаҳатлашинг.*
    `,
    contentRu: `
## Права арендатора в Узбекистане

Аренда жилья в Узбекистане регулируется Гражданским кодексом РУз.

### Основные права арендатора

**1. Право на жилое помещение в надлежащем состоянии**
Арендодатель обязан передать жильё в пригодном для проживания состоянии.

**2. Право на неприкосновенность жилища**
Арендодатель не может входить без предварительного уведомления (как правило, за 24 часа).

**3. Право на своевременный ремонт**
Капитальный ремонт — обязанность арендодателя, текущий — как правило, арендатора.

**4. Возврат залога**
Залог должен быть возвращён в разумный срок после окончания аренды.

### Что делать, если арендодатель нарушает ваши права?

1. Зафиксируйте нарушения письменно
2. Направьте письменную претензию
3. Обратитесь в суд

*Проконсультируйтесь с адвокатом перед подписанием долгосрочного договора аренды.*
    `,
  },
  {
    slug: 'trudovye-spory',
    categoryUz: 'Меҳнат ҳуқуқи',
    categoryRu: 'Трудовое право',
    readTimeUz: '6 дақ',
    readTimeRu: '6 мин',
    titleUz: 'Меҳнат низолари: иш жойидаги ҳуқуқларингизни қандай ҳимоя қилиш',
    titleRu: 'Трудовые споры: как защитить свои права на работе',
    excerptUz: 'Ноқонуний ишдан бўшатиш, иш ҳақи ушланиши, меҳнат шартлари бузилиши — бундай вазиятларда қандай ҳаракат қилиш ва қаёққа мурожаат қилиш кераклигини биліп олинг.',
    excerptRu: 'Незаконное увольнение, задержка зарплаты, нарушение условий труда — узнайте, как действовать в таких ситуациях и куда обращаться.',
    contentUz: `
## Ўзбекистонда меҳнат низолари

Ўзбекистонда меҳнат муносабатлари Меҳнат кодекси билан тартибга солинади. Ишчи кенг ҳуқуқларга эга бўлиб, улар бузилган тақдирда ҳимоя сўраши мумкин.

### Энг кўп учрайдиган бузилишлар

**Ноқонуний ишдан бўшатиш**
Иш берувчи фақат Меҳнат кодексида назарда тутилган асосларда хизматчини бўшата олади. Бўшатиш тартибини бузиш ишга тиклаш ва компенсация олиш ҳуқуқини беради.

**Иш ҳақини кечиктириш ёки тўламаслик**
Иш ҳақи ойига камида икки марта тўланиши шарт. 15 кундан ортиқ кечиктирилса, ишчи иш берувчини ёзма огоҳлантириб, ишни тўхтатиш ҳуқуқига эга.

**Иш жойидаги камситиш**
Жинс, ёш, миллат, дин ва бошқа асосларда камситиш тақиқланган.

### Қаёққа мурожаат қилиш керак?

1. **Меҳнат инспекцияси** — меҳнат қонунчилигини бузганлиги текширилади
2. **Прокуратура** — жиддий тизимли бузилишларда
3. **Суд** — ишга тиклаш ва компенсация ундириш учун

### Мурожаат муддатлари

Меҳнат низолари бўйича судга мурожаат учун қаттиқ муддатлар белгиланган:
- Ишдан бўшатиш масалалари бўйича — буйруқ билан танишилган кундан бошлаб 1 ой
- Бошқа меҳнат низолари бўйича — 3 ой

*Кечиктирманг — адвокатга мурожаат қилинг, муддатлар қатъий сақланади.*
    `,
    contentRu: `
## Трудовые споры в Узбекистане

Трудовые отношения регулируются Трудовым кодексом.

### Наиболее распространённые нарушения

**Незаконное увольнение** — даёт право на восстановление и компенсацию.

**Задержка заработной платы** — при задержке более 15 дней работник вправе приостановить работу.

**Дискриминация** — запрещена по полу, возрасту, национальности, религии.

### Куда обращаться?

1. Инспекция по труду
2. Прокуратура
3. Суд

### Сроки

- По делам об увольнении — 1 месяц
- По иным трудовым спорам — 3 месяца

*Не затягивайте с обращением к адвокату.*
    `,
  },
  {
    slug: 'registraciya-biznesa',
    categoryUz: 'Тижорат ҳуқуқи',
    categoryRu: 'Коммерческое право',
    readTimeUz: '5 дақ',
    readTimeRu: '5 мин',
    titleUz: 'Ўзбекистонда бизнесни рўйхатдан ўтказиш: қаердан бошлаш',
    titleRu: 'Регистрация бизнеса в Узбекистане: с чего начать',
    excerptUz: 'ЯТТ ёки МЧЖ? Ҳар бир шаклнинг афзалликлари ва камчиликлари, ҳужжатлар рўйхати ва my.gov.uz портали орқали рўйхатдан ўтиш тартибини кўриб чиқамиз.',
    excerptRu: 'ИП или ООО? Разбираем плюсы и минусы каждой формы, перечень документов и порядок регистрации через портал my.gov.uz.',
    contentUz: `
## Ўзбекистонда бизнесни рўйхатдан ўтказиш

Ўзбекистонда бизнес юритишнинг турли ташкилий-ҳуқуқий шакллари мавжуд. Энг оммабоплари — якка тартибдаги тадбиркор (ЯТТ) ва масъулияти чекланган жамият (МЧЖ).

### Якка тартибдаги тадбиркор (ЯТТ)

**Афзалликлари:**
- Оддий рўйхатдан ўтиш (my.gov.uz орқали 1 иш куни)
- Соддалаштирилган солиқ ҳисоби
- Устав капиталига минимал талаблар йўқ

**Камчиликлари:**
- Қарзлар бўйича чексиз шахсий жавобгарлик
- Фаолият турлари бўйича чекловлар

### Масъулияти чекланган жамият (МЧЖ)

**Афзалликлари:**
- Жавобгарлик устав капиталидаги улуш миқдори билан чекланади
- Инвесторларни жалб қилиш имконияти
- Контрагентлар ишончи юқори

**Камчиликлари:**
- Мураккаброқ рўйхатдан ўтиш ва бухгалтерия
- Мажбурий устав капитали

### my.gov.uz орқали рўйхатдан ўтиш тартиби

1. my.gov.uz порталида рўйхатдан ўтинг
2. Фаолият турини танланг (ОКОНХ/ОКВЭД)
3. Электрон аризани топшириш
4. Рўйхатдан ўтиш гувоҳномасини олинг

Рўйхатдан ўтиш бепул амалга оширилади.

*Оптимал бизнес тузилмаси ва солиқ режимини танлаш учун юрист билан маслаҳатлашинг.*
    `,
    contentRu: `
## Регистрация бизнеса в Узбекистане

Наиболее популярны индивидуальное предпринимательство (ИП) и общество с ограниченной ответственностью (ООО).

### ИП

**Плюсы:** простая регистрация (1 день через my.gov.uz), упрощённый учёт.
**Минусы:** неограниченная личная ответственность.

### ООО

**Плюсы:** ограниченная ответственность, возможность привлечения инвесторов.
**Минусы:** сложнее регистрация и бухгалтерия.

### Порядок регистрации

1. Зарегистрируйтесь на my.gov.uz
2. Выберите вид деятельности
3. Подайте заявление в электронном виде
4. Получите свидетельство о регистрации

Регистрация осуществляется бесплатно.

*Проконсультируйтесь с юристом для выбора оптимальной структуры.*
    `,
  },
  {
    slug: 'nasledstvo',
    categoryUz: 'Фуқаролик ҳуқуқи',
    categoryRu: 'Гражданское право',
    readTimeUz: '5 дақ',
    readTimeRu: '5 мин',
    titleUz: 'Мерос: ворисларнинг ҳуқуқлари ва расмийлаштириш тартиби',
    titleRu: 'Наследство: права наследников и процедура оформления',
    excerptUz: 'Меросни қандай қабул қилиш, меросхўрлик навбатлари қандай, васиятнома нима ва уни қандай оспорлаш мумкин — батафсил қўлланма.',
    excerptRu: 'Как принять наследство, какие есть очереди наследования, что такое завещание и как его оспорить — подробное руководство.',
    contentUz: `
## Ўзбекистонда мерос

Ўзбекистонда мерос ҳуқуқий муносабатлари ЎзР Фуқаролик кодексининг VI бўлими билан тартибга солинади.

### Меросхўрлик турлари

**Қонун бўйича** — васиятнома бўлмаганда. Меросхўрлар навбатларга бўлинади:
- 1-навбат: болалар, эр/хотин, ота-она
- 2-навбат: ака-ука, опа-сингиллар, бобо-момолар
- 3-навбат: амаки, холалар ва б.

**Васиятнома бўйича** — мерос қолдирувчи мол-мулкни исталган кишига васият қилиш ҳуқуқига эга.

### Меросни қабул қилиш

Мерос мерос қолдирувчи вафот этган кундан бошлаб **6 ой** ичида қабул қилинади:
1. Нотариусга ариза бериш орқали
2. Амалда қабул қилиш (мол-мулкни эгаллаш орқали)

Муддатни ўтказиб юборган тақдирда, узрли сабаблар мавжуд бўлса суд орқали тиклаш мумкин.

### Мажбурий улуш

Вояга етмаган болалар, меҳнатга лаёқатсиз ота-она ва эр/хотин васиятнома бошқа шахс фойдасига тузилган бўлса ҳам меросдан мажбурий улушга (қонун бўйича улушнинг камида 1/2) ҳуқуқлидир.

### Меросга солиқ

2024 йилдан Ўзбекистонда яқин қариндошлар учун мерос солиғи бекор қилинган.

*Меросни расмийлаштириш учун нотариус ёки адвокатга мурожаат қилинг.*
    `,
    contentRu: `
## Наследство в Узбекистане

Наследственные правоотношения регулируются разделом VI Гражданского кодекса РУз.

### Виды наследования

**По закону** — при отсутствии завещания. Очереди: 1-я — дети, супруг(а), родители; 2-я — братья, сёстры, дедушки, бабушки.

**По завещанию** — наследодатель вправе завещать имущество любому лицу.

### Принятие наследства

Наследство принимается в течение **6 месяцев** со дня смерти путём подачи заявления нотариусу или фактического принятия.

### Обязательная доля

Несовершеннолетние дети, нетрудоспособные родители и супруг(а) имеют право на обязательную долю (не менее 1/2 доли по закону).

### Налогообложение

С 2024 года налог на наследство для близких родственников отменён.

*Обратитесь к нотариусу или адвокату для оформления наследства.*
    `,
  },
  {
    slug: 'zashhita-potrebitelej',
    categoryUz: 'Истеъмолчи ҳуқуқи',
    categoryRu: 'Потребительское право',
    readTimeUz: '4 дақ',
    readTimeRu: '4 мин',
    titleUz: 'Истеъмолчи ҳуқуқларини ҳимоя қилиш: сифатсиз товар учун пул қайтариш',
    titleRu: 'Защита прав потребителей: как вернуть деньги за некачественный товар',
    excerptUz: 'Сифатсиз товар сотиб олдингизми ёки ёмон хизмат олдингизми? Ҳуқуқларингиз ва сотувчига даъво қўйиш тартиби ҳақида билинг.',
    excerptRu: 'Купили некачественный товар или получили плохую услугу? Узнайте о своих правах и порядке предъявления претензии продавцу.',
    contentUz: `
## Ўзбекистонда истеъмолчи ҳуқуқларини ҳимоя қилиш

Ўзбекистонда истеъмолчилар ҳуқуқлари «Истеъмолчилар ҳуқуқларини ҳимоя қилиш тўғрисида»ги Қонун ва ЎзР Фуқаролик кодекси билан ҳимоя қилинади.

### Сифатсиз товар сотиб олинганда ҳуқуқлар

Товарда нуқсон аниқланганда сиз қуйидагиларни талаб қилиш ҳуқуқига эгасиз:
1. **Алмаштириш** — шу каби тегишли сифатли товарга алмаштириш
2. **Нархни камайтириш** — мутаносиб равишда
3. **Бепул тузатиш** — нуқсонларни бартараф этиш (таъмирлаш)
4. **Тўланган пулни қайтариш** — шартномани бекор қилиш

### Даъво қўйиш муддатлари

- Умумий қоида бўйича — **кафолат муддати** ичида
- Кафолат муддати белгиланмаган бўлса — оқилона муддатда, аммо **2 йил**дан кечиктирмай
- Узоқ муддатли фойдаланиладиган товарлар учун — **10 йил**гача

### Ҳаракатлар тартиби

1. Икки нусхада ёзма даъво тузинг
2. Сотувчига даъвони топшириб, имзо олинг
3. Барча чекlar, шартномалар ва ёзишмаларни сақланг
4. Рад этилган тақдирда — судга мурожаат қилинг

### Қаёққа шикоят қилиш керак?

- **Истеъмолчилар ҳуқуқларини ҳимоя қилиш агентлиги** — судсиз ҳал этиш учун
- **Суд** — зарар ва жарима ундириш учун

Судда даъво қондирилса, сотувчи даъво суммасининг 50% миқдорида жарима тўлашга мажбур.

*Муваффақият имкониятларингизни баҳолаш учун адвокат билан маслаҳатлашинг.*
    `,
    contentRu: `
## Защита прав потребителей в Узбекистане

Права потребителей защищаются Законом «О защите прав потребителей» и Гражданским кодексом РУз.

### Права при покупке некачественного товара

При обнаружении недостатков вы вправе потребовать:
1. **Замены** товара
2. **Уменьшения** цены
3. **Безвозмездного устранения** недостатков
4. **Возврата** уплаченной суммы

### Сроки предъявления претензий

- По общему правилу — в течение гарантийного срока
- Если не установлен — не позднее 2 лет
- По товарам длительного пользования — до 10 лет

### Порядок действий

1. Составьте письменную претензию в двух экземплярах
2. Вручите продавцу, потребовав подпись
3. Сохраните все чеки и переписку
4. При отказе — обратитесь в суд

*Проконсультируйтесь с адвокатом для оценки ваших шансов.*
    `,
  },
];

const categoryColors = {
  'Оила ҳуқуқи':       { bg: '#fef3c7', color: '#92400e' },
  'Уй-жой ҳуқуқи':    { bg: '#dbeafe', color: '#1e40af' },
  'Меҳнат ҳуқуқи':    { bg: '#d1fae5', color: '#065f46' },
  'Тижорат ҳуқуқи':   { bg: '#ede9fe', color: '#5b21b6' },
  'Фуқаролик ҳуқуқи': { bg: '#fee2e2', color: '#991b1b' },
  'Истеъмолчи ҳуқуқи':{ bg: '#ccfbf1', color: '#0f766e' },
  'Семейное право':    { bg: '#fef3c7', color: '#92400e' },
  'Жилищное право':    { bg: '#dbeafe', color: '#1e40af' },
  'Трудовое право':    { bg: '#d1fae5', color: '#065f46' },
  'Коммерческое право':{ bg: '#ede9fe', color: '#5b21b6' },
  'Гражданское право': { bg: '#fee2e2', color: '#991b1b' },
  'Потребительское право': { bg: '#ccfbf1', color: '#0f766e' },
};

// ── Featured (static) articles shown as cards on /legal-topics ──
const FEATURED_ARTICLES = [
  {
    slug: 'ajrashish-jarayoni',
    category: 'Оила ҳуқуқи',
    readTime: '10 дақиқа ўқиш',
    title: 'Ўзбекистонда ажрашиш жараёни: ажримга (онлайн) ариза бериш тартиби, давлат божи',
    excerpt: 'ФҲДЁ ёки суд? Қандай ҳужжатлар, қанча давлат божи, неча ой давом этади. Иккита йўл бор — ва бу мақола сизнинг ҳолатингиз қайси бирига мос келишини тушунтиради.',
    author: 'Болтабоев Ахрор',
    authorUrl: 'https://advokattop.uz/attorney/44',
    date: '12 июнь 2026',
  },
  {
    slug: 'intizomiy-jazolar',
    category: 'Меҳнат ҳуқуқи',
    readTime: '8 дақиқа ўқиш',
    title: 'Ҳайфсан ёки 30 фоиз жарима ёки ишдан бўшатиш ҳар доим ҳам қонуний бўлавермайди...',
    excerpt: 'Меҳнат кодекси иш берувчига ходимга нисбатан интизомий жазо қўллашга ҳуқуқ беради — лекин фақат қатъий тартибга риоя қилган холда. Уч турдаги жазо, 4 та мажбурий талаб, ва интизомий жазо ноқонуний қўлланилганда нима қилишингиз мумкин.',
    author: 'Акмал Ҳасанов',
    authorUrl: 'https://advokattop.uz/attorney/42',
    date: '15 июнь 2026',
  },
];

// ── Article list page ──────────────────────────────────────────
const ArticleList = () => {
  const { t, language } = useLanguage();
  const isRu = language === 'ru';
  const [dbArticles, setDbArticles] = useState([]);

  useEffect(() => {
    let active = true;
    articleAPI.listPublished()
      .then((res) => {
        if (!active) return;
        const mapped = res.data.map((a) => ({
          slug: a.slug,
          category: a.category ? t(`practiceAreas.${a.category}`) : '',
          readTime: a.read_time_min ? `${a.read_time_min} дақиқа ўқиш` : '',
          title: a.title,
          excerpt: a.excerpt || '',
          author: a.author_name,
          authorUrl: `/attorney/${a.attorney_id}`,
          date: a.published_at ? formatPublishedDate(a.published_at) : '',
        }));
        setDbArticles(mapped);
      })
      .catch(() => setDbArticles([]));
    return () => { active = false; };
  }, [t]);

  const allArticles = [...FEATURED_ARTICLES, ...dbArticles];

  return (
    <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '2.5rem 2rem' }}>
      <div style={{ marginBottom: '2.5rem' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: '800', color: '#1a365d', marginBottom: '0.5rem' }}>
          {t('nav.legalTopics')}
        </h1>
        <p style={{ color: '#718096', fontSize: '1rem' }}>
          {isRu
            ? 'Бесплатные юридические статьи и ответы на популярные вопросы'
            : 'Ҳуқуқий саводхонлигингизни оширинг — бепул мақолалар ва кенг тарқалган саволларга жавоблар'}
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '1.5rem' }}>
        {allArticles.map(article => {
          const colors = categoryColors[article.category] || { bg: '#f7fafc', color: '#4a5568' };

          return (
            <a
              key={article.slug}
              href={`/legal-topics/${article.slug}`}
              style={{
                backgroundColor: 'white', borderRadius: '12px', padding: '1.5rem',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer',
                border: '1px solid #e2e8f0', transition: 'transform 0.15s, box-shadow 0.15s',
                textDecoration: 'none', display: 'flex', flexDirection: 'column',
              }}
              onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.12)'; }}
              onMouseOut={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)'; }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                <span style={{ backgroundColor: colors.bg, color: colors.color, padding: '0.2rem 0.65rem', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '600' }}>
                  {article.category}
                </span>
                <span style={{ fontSize: '0.78rem', color: '#a0aec0' }}>
                  {article.readTime}
                </span>
              </div>
              <h3 style={{ fontSize: '1.05rem', fontWeight: '700', color: '#1a365d', marginBottom: '0.65rem', lineHeight: '1.4' }}>
                {article.title}
              </h3>
              <p style={{ fontSize: '0.88rem', color: '#718096', lineHeight: '1.6', flex: 1 }}>
                {article.excerpt}
              </p>
              <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', paddingTop: '1rem', borderTop: '1px solid #edf2f7' }}>
                <div style={{ fontSize: '0.8rem', color: '#a0aec0', lineHeight: '1.5' }}>
                  <div style={{ color: '#2d3748', fontWeight: '600' }}>{article.author}</div>
                  <div>{article.date}</div>
                </div>
                <span style={{ color: '#3182ce', fontSize: '0.85rem', fontWeight: '500', whiteSpace: 'nowrap' }}>
                  Батафсил →
                </span>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

const renderContent = (text) => {
  return text.split('\n').map((line, i) => {
    if (line.startsWith('## ')) return <h2 key={i} style={{ fontSize: '1.5rem', fontWeight: '800', color: '#1a365d', margin: '1.5rem 0 0.75rem' }}>{line.slice(3)}</h2>;
    if (line.startsWith('### ')) return <h3 key={i} style={{ fontSize: '1.15rem', fontWeight: '700', color: '#2d3748', margin: '1.25rem 0 0.5rem' }}>{line.slice(4)}</h3>;
    if (line.startsWith('**') && line.endsWith('**')) return <p key={i} style={{ fontWeight: '700', color: '#2d3748', margin: '0.75rem 0 0.25rem' }}>{line.slice(2, -2)}</p>;
    if (line.match(/^\d+\.\s/)) return <li key={i} style={{ marginLeft: '1.5rem', marginBottom: '0.3rem', color: '#4a5568' }}>{line.replace(/^\d+\.\s/, '')}</li>;
    if (line.startsWith('- ')) return <li key={i} style={{ marginLeft: '1.5rem', marginBottom: '0.3rem', color: '#4a5568' }}>{line.slice(2)}</li>;
    if (line.startsWith('*') && line.endsWith('*')) return <p key={i} style={{ fontStyle: 'italic', color: '#718096', borderLeft: '3px solid #3182ce', paddingLeft: '1rem', margin: '1.25rem 0' }}>{line.slice(1, -1)}</p>;
    if (line.trim() === '') return <div key={i} style={{ height: '0.5rem' }} />;
    return <p key={i} style={{ color: '#4a5568', lineHeight: '1.75', marginBottom: '0.5rem' }}>{line}</p>;
  });
};

// ── Article detail page ────────────────────────────────────────
const ArticleDetail = ({ slug }) => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const isRu = language === 'ru';
  const article = ARTICLES.find(a => a.slug === slug);

  if (!article) {
    return (
      <div style={{ maxWidth: '800px', margin: '3rem auto', padding: '2rem', textAlign: 'center' }}>
        <h2 style={{ color: '#1a365d' }}>{isRu ? 'Мақола топилмади' : 'Мақола топилмади'}</h2>
        <button onClick={() => navigate('/legal-topics')} style={{ marginTop: '1rem', color: '#3182ce', background: 'none', border: 'none', cursor: 'pointer', fontSize: '1rem' }}>
          ← {isRu ? 'Все статьи' : 'Барча мақолалар'}
        </button>
      </div>
    );
  }

  const title    = isRu ? article.titleRu    : article.titleUz;
  const content  = isRu ? article.contentRu  : article.contentUz;
  const category = isRu ? article.categoryRu : article.categoryUz;
  const readTime = isRu ? article.readTimeRu : article.readTimeUz;
  const colors   = categoryColors[category] || { bg: '#f7fafc', color: '#4a5568' };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2.5rem 2rem' }}>
      <div style={{ marginBottom: '1.5rem', fontSize: '0.88rem', color: '#a0aec0' }}>
        <Link to="/" style={{ color: '#a0aec0', textDecoration: 'none' }}>
          {isRu ? 'Главная' : 'Бош саҳифа'}
        </Link>
        {' / '}
        <Link to="/legal-topics" style={{ color: '#a0aec0', textDecoration: 'none' }}>
          {isRu ? 'Правовые темы' : 'Ҳуқуқий мавзулар'}
        </Link>
        {' / '}
        <span style={{ color: '#4a5568' }}>{title}</span>
      </div>

      <div style={{ backgroundColor: 'white', borderRadius: '16px', padding: '2.5rem', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.25rem' }}>
          <span style={{ backgroundColor: colors.bg, color: colors.color, padding: '0.25rem 0.75rem', borderRadius: '12px', fontSize: '0.8rem', fontWeight: '600' }}>
            {category}
          </span>
          <span style={{ color: '#a0aec0', fontSize: '0.82rem' }}>
            {isRu ? `${readTime} чтения` : `${readTime} ўқиш`}
          </span>
        </div>

        <h1 style={{ fontSize: '1.75rem', fontWeight: '800', color: '#1a365d', lineHeight: '1.3', marginBottom: '1.5rem' }}>
          {title}
        </h1>

        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '1.5rem' }}>
          {renderContent(content)}
        </div>
      </div>

      <div style={{ marginTop: '2rem', backgroundColor: '#ebf8ff', borderRadius: '12px', padding: '1.5rem', textAlign: 'center', border: '1px solid #bee3f8' }}>
        <h3 style={{ color: '#1a365d', fontWeight: '700', marginBottom: '0.5rem' }}>
          {isRu ? 'Нужна личная консультация?' : 'Шахсий маслаҳат керакми?'}
        </h3>
        <p style={{ color: '#2b6cb0', fontSize: '0.92rem', marginBottom: '1rem' }}>
          {isRu
            ? 'Свяжитесь с квалифицированным адвокатом прямо сейчас'
            : 'Ҳозироқ малакали адвокат билан боғланинг'}
        </p>
        <button
          onClick={() => navigate('/find-attorney')}
          style={{ backgroundColor: '#1a365d', color: 'white', border: 'none', padding: '0.75rem 2rem', borderRadius: '8px', fontWeight: '600', fontSize: '0.95rem', cursor: 'pointer' }}
        >
          {isRu ? 'Найти адвоката' : 'Адвокат топиш'}
        </button>
      </div>

      <div style={{ marginTop: '1.5rem' }}>
        <button
          onClick={() => navigate('/legal-topics')}
          style={{ color: '#3182ce', background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.9rem' }}
        >
          ← {isRu ? 'Все статьи' : 'Барча мақолалар'}
        </button>
      </div>
    </div>
  );
};

// ── Router wrapper ─────────────────────────────────────────────
const LegalTopics = () => {
  const { slug } = useParams();
  if (slug) return <ArticleDetail slug={slug} />;
  return <ArticleList />;
};

export default LegalTopics;
